import React, { useEffect, useState } from "react";
import EmployeeProfileCard from "../../../Employee/components/EmployeeProfileCard";
import PageHeader from "../../../../Component/BasicComponents/HeaderBreadCrumbs";
import AccountDetails from "./AccountDetails";
import PrimaryMappingTable from "./PrimaryMappingTable";
import AddressTable from "./AddressTable";
import OrganizationCustomerRecord from './OrganizationCustomerRecord'
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import CustomerModal from "../Modal/CustomerModal";
import { useLocation } from "react-router-dom";
import { useOutletById } from "../hooks/useCustomer";

const CustomerProfileScreen: React.FC = () => {
  const [mode, setmode] = useState<"add" | "edit">("add");
   const [outletId, setOutletId] = useState<number | null>(null);

  const location=useLocation()
  console.log('Location Outlet Id',location.state.outletId)
  console.log('outletId',outletId)
  useEffect(() => {
    if (location.state?.outletId) {
      setOutletId(location.state.outletId);
    }
  }, [location.state]);

  const {data:getOutlet,isLoading}=useOutletById({
    enabled:!!outletId,
   outletId:outletId
  })


  const [isModal,setIsModal] = useState(false);
  
  const RequiredFiled = {
    Name:"OutletContactName",
    EmployeeCode:"OutletCode",
    OutletType: "OutletTypeName",
    Classification:"ClassificationName",
    OutletName:'OutletName',
    LegacyCode:'OutletCode',
    ContactName:'OutletContactName',
    Contact:'OutletContactNo',
    Email:'OutletEmail',
    OpeningDate:'OutletOpeningDate',
    Salutation:'OutletSalutation',
    DateOfBirth:'OutletContactBday',
    MaritalStatus:'OutletMaritalStatus',
    Anniversary:'OutletContactAnniversary',
    Potential:'OutletPotential',
    Qualification:'OutletQualification',
    Regno:'OutletRegno',
    Status:'OutletStatus'
    // ProfilePicture: "ProfilePicture",
  };

  
  const customStyles ={
    container:{ 
      display: "flex",
      // flexDirection: "row",
      alignItems: "center",
      backgroundColor: "#e6f7f9",
      padding: "24px",
      borderRadius: "16px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      width: "100%",
      maxWidth: "100%",
      flex: "1 1 0",
      gap:'6%',
      height: '95%'
    },
    imageContainer: {
      width: "70%",
      height: "50%",
      borderRadius: "50%",
      overflow: "hidden",
      marginBottom: "16px",
      backgroundColor: "#fff",
      marginLeft:'16xp'
    },
    detailsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
      gap: "40px",
      width: "100%",
    },
    // imageOuterContainer:{
        //  display: "flex",
        // flexDirection: "column",
        // width: "36%",
        // marginLeft:'10px',
        // alignItems: "center",
        // justifyContent: "center",
    // }

  }

      const oncloseModal = () => {
    setIsModal(false);
  };

  const editCustomerDetailHandler = ()=>{
    setIsModal(true);
    setmode('edit')
  }

  return (
    <div className="p-2">
      <PageHeader title="Customer Profile"buttons={[
        {
            label:'Edit',
            onClick:editCustomerDetailHandler,
            color:'#2e8dd3'
        }
      ]} />
  
      <div className="row mb-3">
        <div className="col-md-12" style={{height:'50xp'}}>
          <EmployeeProfileCard isloading={isLoading} media={getOutlet?.data?.OutletsData?.OutletMediaId} onEditProfileClick={editCustomerDetailHandler} profileEdit={false} customStyles={customStyles} requiredFields={RequiredFiled} employeeData={getOutlet?.data?.OutletsData} showStatusToggle={false}  />
        </div>
      </div>
  
      <div className="row mb-3">
        <div className="col-md-6">
          <PrimaryMappingTable Outlet_Id={outletId} />
        </div>
        <div className="col-md-6">
        <AddressTable OutletId={outletId}  />
        </div>
      </div>
  
      <div className="row mb-3">
        <div className="col-12">
          <OrganizationCustomerRecord OutletId={outletId} employeeData={getOutlet?.data?.OutletsData} />
        </div>
      </div>

  <div className="row mb-3">
        <div className="col-12">
          <AccountDetails  />
        </div>
      </div>

      <RouteModal
           size='xl'
           isOpen={isModal}
           title='Edit Outlet'
           toggle={()=>setIsModal(!isModal)}
           content={
            <CustomerModal 
            mode={mode}
            modalClose={oncloseModal}
            customerID={location?.state?.outletId}
            />
           }
        />
    </div>
  );
  
};
export default CustomerProfileScreen;
